import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useMemo, useState } from 'react';

import FieldToolTip from '@/components/forms/new/FieldToolTip';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';
import { CustomRegistrationOption } from './CustomRegistrationOption';

import appConfig from '@/config.json';
import walkthroughIds from '../../walkthroughIds';

const notAllocated = {
    id: null,
    extension: appConfig.notAllocated.dropdown,
    used: false,
    isDisabled: false,
};

const TRSRegistrationDropdown = ({
    data,
    setCurrentNumber,
    errors,
    touched,
    darkMode,
    trsRegistrations = [],
    registrationData,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const fieldName = 'formValues[0].registrationID';

    const enhancedRegistrations = useMemo(() => {
        let combinedRegistrations = [...trsRegistrations];

        // Only add registrationData if it's not already in the list
        if (registrationData) {
            const isAlreadyInList = trsRegistrations.some(
                (item) => item.id === registrationData.id,
            );
            if (!isAlreadyInList) {
                combinedRegistrations.push(registrationData);
            }
        }

        const availableRegistrations = combinedRegistrations
            .filter(Boolean)
            .sort(
                (a, b) =>
                    Number.parseInt(a.extension) - Number.parseInt(b.extension),
            );

        return [notAllocated, ...availableRegistrations];
    }, [trsRegistrations, registrationData]);

    const handleSelectChange = (selectedOption) => {
        console.log({ selectedOption });
        // Prevent selection of disabled options
        if (selectedOption?.isDisabled) {
            return;
        }

        setCurrentNumber((prev) => ({
            ...prev,
            registrationID: selectedOption?.id || '',
        }));
    };

    // Function to check if option should be disabled
    const isOptionDisabled = (option) => {
        return option.isDisabled;
    };

    const getTrsRegistrationLabel = (option) =>
        option.registrar
            ? `${option.extension} (${option.registrar.name})`
            : option.extension;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={errors?.registrationID && touched?.registrationID}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        TRS Registration
                    </FormLabel>
                </Box>
                <Field
                    component={DropDown}
                    id={fieldName}
                    name={fieldName}
                    shownValue={getTrsRegistrationLabel}
                    selectedId="id"
                    currentId={data?.registrationID}
                    handleSelectChange={handleSelectChange}
                    darkMode={darkMode}
                    data={enhancedRegistrations}
                    alphabetical={false}
                    isDisabled={!enhancedRegistrations?.length}
                    placeholder="Select registration"
                    isOptionDisabled={isOptionDisabled}
                    components={{
                        Option: (props) => (
                            <CustomRegistrationOption
                                darkMode={darkMode}
                                {...props}
                            />
                        ),
                    }}
                    data-walkthroughid={
                        walkthroughIds.editNumbersGeneral.editPlatformNumbers
                            .ufRegistration
                    }
                />
                {isHovered && (
                    <FieldToolTip
                        label="Choose a Registration Extension."
                        ariaLabel="numbers-registrationIDdropdown-tooltip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default TRSRegistrationDropdown;
